import {
    createApp,
    Vue
} from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import VueCookies from 'vue-cookies'
// import VueParticles from 'vue-particles'

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'


//引入字体
import '@/assets/fonts/font.css'
// 引入iconfont
import "@/assets/iconfont/iconfont.css"

// 强制覆盖主view-ui-plus主题色
import '@/theme/index.css'
createApp(App).use(router).use(ViewUIPlus).use(VueCookies).use(ContextMenu).mount('#app')





